import { render } from "./RenewAd.vue?vue&type=template&id=61d95c3e"
import script from "./RenewAd.vue?vue&type=script&lang=js"
export * from "./RenewAd.vue?vue&type=script&lang=js"
script.render = render

export default script